var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-chart position-relative",attrs:{"id":"chartdiv"}},[(_vm.isLoading)?_c('div',{staticClass:"map-loading"},[_c('BSpinner',{staticClass:"map-spinner",attrs:{"variant":"primary"}})],1):_vm._e(),_c('div',{staticClass:"w-100 h-100",attrs:{"id":"risk-google-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }